module.exports = "https://www.gc-qa.gnp.com.mx/605f6234dd3a2b56e5e15b7bd7b299c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/add-photo-new.svg
// module id = 213
// module chunks = 0